<template>
<v-dialog
    v-model="dialog"
    max-width="600"
>
    <v-card>
    <v-card-title class="headline">Edit Label</v-card-title>

    <v-card-text>
        <v-text-field
            label="Phone Number"
            v-model="phone_number"
            ref="phone_number"
            disabled
            autocomplete="off"
        />

        <v-text-field
            label="Label"
            v-model="label"
            ref="label"
            autocomplete="off"
        />
    </v-card-text>

    <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn
            color="gray darken-1"
            text
            @click="dialog = false"
        >
        Cancel
        </v-btn>

        <v-btn
            color="primary darken-1"
            text
            @click="onOk"
            :disabled="!valid"
        >
        Ok
        </v-btn>
    </v-card-actions>
    </v-card>
</v-dialog>
</template>

<script>

const E164 = require('@/js/E164.js');

export default {
    data() {
        return {
            dialog: false,
            
            endpoint: '',
            phone_number: '',
            label: '',

            valid: false,
        }
    },

    methods: {
        showDialog(endpoint, cur_label) 
        {
            this.endpoint = endpoint;
            this.label = cur_label;
            this.phone_number = E164.prettyPrintUsPhoneNumber(endpoint);

            this.dialog = true;    

            setTimeout(() => {this.setFocusLabel()}, 200)
        },

        validate()
        {
            this.valid = this.label.length > 0;
        },


        setFocusLabel()
        {
            this.$refs.label.focus();
        },
        
        onOk()
        {
           this.dialog = false;

           let message = {
               'endpoint': this.endpoint,
               'label': this.label,
           };

           this.$emit('edit-label', message);
        }
    },

    watch: {
        label(newValue, oldValue) 
        {
            this.validate();
        },
    },
}
</script>

<style lang="scss" scoped>

</style>